import axiosInstance from "api/axiosInstance"
import { batch } from "react-redux"
import { returnRequestAction } from "./return-request-slice"
import SAlert from "components/Alert"

export const createReturnRequest = (data, callback) => dispatch => {
  dispatch(returnRequestAction.setLoading(true))
  axiosInstance
    .post("/v1/return-request", data)
    .then(() => {
      SAlert({
        title: "Success",
        text: " Re-allocation request created successfully",
      })
      batch(() => {
        dispatch(returnRequestAction.setError(null))
        dispatch(returnRequestAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(returnRequestAction.setLoading(false))
      SAlert({
        title: "Error",
        text: error?.response?.data?.error || "Failed to create return request",
        status: "error",
      })
      if (callback) callback(false)
    })
}

export const getReturnRequests =
  (pageNumber = 10, status = null) =>
  dispatch => {
    dispatch(returnRequestAction.setLoading(true))
    axiosInstance
      .get("/v1/return-requests", {
        params: { pageNumber, status },
      })
      .then(response => {
        batch(() => {
          dispatch(returnRequestAction.setError(null))
          dispatch(returnRequestAction.setData(response.data))
          dispatch(returnRequestAction.setLoading(false))
        })
      })
      .catch(error => {
        dispatch(returnRequestAction.setLoading(false))
        console.log(error)
      })
  }

export const approveReturnRequests = (ids, adminNote, callback) => dispatch => {
  dispatch(returnRequestAction.setLoading(true))
  axiosInstance
    .post("/v1/return-requests/approve", { ids, admin_note: adminNote })
    .then(() => {
      SAlert({
        title: "Success",
        text: "Return requests approved successfully",
      })
      dispatch(getReturnRequests())
      batch(() => {
        dispatch(returnRequestAction.setError(null))
        dispatch(returnRequestAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(returnRequestAction.setLoading(false))
      SAlert({
        title: "Error",
        text:
          error?.response?.data?.error || "Failed to approve return requests",
        status: "error",
      })
      if (callback) callback(false)
    })
}

export const rejectReturnRequests = (ids, adminNote, callback) => dispatch => {
  dispatch(returnRequestAction.setLoading(true))
  axiosInstance
    .post("/v1/return-requests/reject", { ids, admin_note: adminNote })
    .then(() => {
      SAlert({
        title: "Success",
        text: "Return requests rejected successfully",
      })
      dispatch(getReturnRequests())
      batch(() => {
        dispatch(returnRequestAction.setError(null))
        dispatch(returnRequestAction.setLoading(false))
      })
      if (callback) callback(true)
    })
    .catch(error => {
      dispatch(returnRequestAction.setLoading(false))
      SAlert({
        title: "Error",
        text:
          error?.response?.data?.error || "Failed to reject return requests",
        status: "error",
      })
      if (callback) callback(false)
    })
}

export const getReturnedItems =
  (pageNumber = 10) =>
  dispatch => {
    dispatch(returnRequestAction.setLoading(true))
    axiosInstance
      .get("/v1/returned-items", {
        params: { pageNumber },
      })
      .then(response => {
        batch(() => {
          dispatch(returnRequestAction.setError(null))
          dispatch(returnRequestAction.setData(response.data))
          dispatch(returnRequestAction.setLoading(false))
        })
      })
      .catch(error => {
        dispatch(returnRequestAction.setLoading(false))
        console.log(error)
      })
  }
